<template>
    <div>
    <el-form size="mini" label-width="120px">
        <el-row v-if="isShowTitle" style="margin-top: -2%;">
            <el-col :span="12">
                <el-form-item label="流程模板">
                    <el-input disabled v-model="processInstance.processServiceName"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="流程实例名称" >
                    <el-input  disabled v-model="processInstance.name" />
                </el-form-item>
            </el-col>
        </el-row>
        <div >
            <div >
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="流程任务节点列表" name="processTask">
                    <div class="tools-bar" style="float:right;">
                        <div class="tools-btn-group">
                            <el-tooltip content="假如通过修改任务负责人失败，可以先使用批量移除任务负责人，再修改任务负责人" placement="top">
                              <el-button v-if="batchTaskAssigneeUserChange" type="danger" icon="el-icon-s-check" @click="batchTaskRemoveUser">批量移除任务负责人</el-button>
                            </el-tooltip>
                            <el-tooltip content="批量变更任务负责人" placement="top">
                                <el-button v-if="batchTaskAssigneeUserChange" type="primary" icon="el-icon-s-check" @click="batchTaskChooseUser">批量变更任务负责人</el-button>
                            </el-tooltip>
                            <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowBatchTaskAssignerDialog'  :selectedUser="batchTaskSelectedUser" ref="batchTaskUserOrgPop" @nodeClick="batchTaskSelectTrigger"  /> 
                            <el-button icon="el-icon-download" type="primary" title="导出" @click.stop="exportAllUserTaskToExcel()">导出</el-button>
                            <!-- <el-tooltip content="保存为常用负责人配置后，用该流程的流程模板发起流程时可以选择使用配置来快速发起流程" placement="top">
                                <el-button type="primary" v-if="processInstance && processInstance.finish && processInstance.startedBy.id==userInfo.userId && !processInstance.commonUse" icon="el-icon-folder-checked" @click="saveProcessCommonUseConfig">保存为常用配置</el-button>
                            </el-tooltip> -->
                        </div>
                    </div>
                    <el-table 
                        :data="taskList" 
                        height="400px" 
                        :border="true" 
                        @selection-change="handleSelectionTaskRows"
                        tooltip-effect="dark"
                        stripe>
                        <el-table-column  type="index" width="40"> </el-table-column>
                        <el-table-column v-if="batchTaskAssigneeUserChange"  type="selection" width="55"></el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" width="160" prop="taskName" label="任务节点" ></el-table-column>
                        <el-table-column  width="80"  label="任务类型" >
                            <template slot-scope="scope">
                            <el-tag type="danger" v-if="scope.row.executor.modeType === 2" >会签</el-tag>
                            <el-tag type="warning" v-else-if="scope.row.executor.modeType === 99" >子流程</el-tag>
                            <template  v-else >常规</template>
                            </template>
                        </el-table-column>
                        <el-table-column   width="90" prop="taskStatus" label="任务状态" >
                            <!-- taskStatus// 任务详细状态 0未开始 1未分配 2待认领 3进行中 4快到期 5已完成 6已延期 -->
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.taskStatus === 0" type="info" plain>未开始</el-button>
                                <el-button v-if="scope.row.taskStatus === 1" type="unassigned" >未分配</el-button>
                                <el-button v-if="scope.row.taskStatus === 2" type="unclaimed" >待认领</el-button>
                                <el-button v-if="scope.row.taskStatus === 3" type="primary" >进行中</el-button>
                                <el-button v-if="scope.row.taskStatus === 4" type="warning" >快到期</el-button>
                                <el-button v-if="scope.row.taskStatus === 5" type="success" >已完成</el-button>
                                <el-button v-if="scope.row.taskStatus === 6" type="danger" >已延期</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column  width="150" label="任务难度级别" >
                            <template slot-scope="scope">
                                <!-- <span v-if="scope.row.nodeInfo.difficultLevel === 0" >简单</span>
                                <span v-if="scope.row.nodeInfo.difficultLevel === 1" >中等</span>
                                <span v-if="scope.row.nodeInfo.difficultLevel === 2" >困难</span> -->
                                <el-rate disabled v-model="scope.row.nodeInfo.difficultLevel" :colors="colors"></el-rate>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column   width="180" prop="users" label="参与人员" ></el-table-column>  -->
                        <el-table-column   width="70" label="负责人" >
                            <template slot-scope="scope">
                                <div  v-if="scope.row.executor.modeType === 0 && scope.row.executor.hasOwnProperty('assigneeUsers')" style="cursor:pointer;" @click.stop="handleChooseAssignee(scope.row)">
                                    {{scope.row.executor.assigneeUsersName}}
                                </div>
                                <div  v-if="scope.row.executor.modeType === 2 && scope.row.executor.hasOwnProperty('countersignUsers')" style="cursor:pointer;" @click.stop="handleChooseAssignee(scope.row)">
                                    {{scope.row.executor.countersignUsersName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column   width="70" prop="executor.candidateUsersName" :show-overflow-tooltip="true" label="候选人(抄送)" ></el-table-column>
                        <el-table-column   width="70" prop="executor.participantUsersName" :show-overflow-tooltip="true" label="参与人" ></el-table-column>
                        <!-- <el-table-column  width="95" label="计划开始时间" >
                            <template slot-scope="scope">
                            <span v-if="scope.row.nodeInfo.hasOwnProperty('planStartDate')">  {{scope.row.nodeInfo.planStartDate}}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column  v-if="processInstance.hasOwnProperty('id')" width="100" :show-overflow-tooltip="true" label="实际开始时间" >
                            <template slot-scope="scope">
                            <span v-if="scope.row.nodeInfo.hasOwnProperty('actualStartTime')">  {{scope.row.nodeInfo.actualStartTime}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column  width="100" :show-overflow-tooltip="true" label="计划完成时间" ><!-- 到期时间 -->
                            <template slot-scope="scope">
                            <span v-if="scope.row.nodeInfo.hasOwnProperty('dueDate')">  {{scope.row.nodeInfo.dueDate}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column  v-if="processInstance.hasOwnProperty('id')" :show-overflow-tooltip="true" width="100"  label="实际完成时间" >
                            <template slot-scope="scope">
                            <span v-if="scope.row.nodeInfo.hasOwnProperty('actualEndTime')">  {{scope.row.nodeInfo.actualEndTime}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" width="120" label="数据表单" >
                            <template slot-scope="scope">
                            <span v-if="scope.row.hasOwnProperty('forms')">  {{scope.row.forms}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" width="120" prop="operateOpinion" label="审批意见" ></el-table-column>
                        <el-table-column   min-width="120" prop="btns" label="操作按钮" ></el-table-column>
                        <!-- <el-table-column  :show-overflow-tooltip="true" width="200" prop="variables" label="流程变量" ></el-table-column> -->
                        <el-table-column v-if="this.processInstance.id && isShowTitle" fixed="right" label="操作" width="70">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" icon="el-icon-setting" title="设置" circle @click.stop="handleChange(scope.row)"></el-button>
                            </template>
                        </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane v-if="!isNexTaskConfig" label="档案模板列表" name="archiveTemplate">
                        <tree-table :tbHeight="'430'" :data="archiveTemplateTreeList" :isShowCheckbox="false" :expandAll="true" :columns="archiveTemplateTreeColumns" border/>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
                    <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
                </el-tabs>
            </div>
        </div>
      </el-form>
    <div>
        <el-dialog
              custom-class="task-edit-dialog"
              :title="taskTile"
              :visible.sync="isShowEleEditor"
              top="2vh"
              width="88%"
              :fullscreen="true"
              append-to-body 
              >
              <!-- 用户任务 节点 -->
              <ElementEditor :isNexTaskConfig="isNexTaskConfig" :taskData="taskData" :processInstance="processInstance" @hideMainSaveBtn="hideMainSaveBtn"/> 
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowEleEditor = false">取 消</el-button>
                  <el-button v-if="isShowSaveBtn && processInstance.id!='-1' " type="primary" :loading="!isShowEleEditor" @click="handleSaveConfig">保存配置</el-button>
              </span>
          </el-dialog>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { isEmpty, defaultsDeep } from 'lodash';
    import ElementEditor from '../ProcessEditor/components/ElementEditor';
    import { defaultElementData } from './defaultData';
    import { saveProcessCommonUseConfig, getUserList, getProcessServiceInstanceConfig, interveneProcessTaskConfig, batchChangeTaskAssigneeUser, deleteProcessInstanceUserForced } from '@/data-model';
    import TreeTable from '@/components/TreeTable';
    import { API_PROCESS_INSTANCE_ALL_TASK_TO_EXCEL } from '@/common/constants';

    export default {
        components: {
            ElementEditor,
            TreeTable
        },
        data () {
            return {
                loadTimer: '',
                isShowBatchTaskAssignerDialog: false,
                batchTaskSelectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                selectedTaskIds: '', // 当前选择的批量任务id
                selectedTaskInstanceIds: '', // 当前选择的批量任务实例id
                selectedAssingers: '', // 当前选择的批量任务负责人id
                batchAuthTaskList: [], // 当前选择的批量任务列表
                // taskList:[]
                colors: ['#99A9BF', '#FFDC35', '#FF9900'],
                activeName: 'processTask',
                isShowEleEditor: false,
                taskData: {},
                isShowSaveBtn: true,
                taskTile: '',
                // archiveTemplateTreeList: [], // 档案模板树型列表数据
                archiveTemplateTreeColumns: [
                    {
                        text: '序号',
                        value: 'orderNum',
                        width: 200
                    }, {
                        text: '名称',
                        value: 'label',
                        width: 200
                    }, {
                        text: '备注说明',
                        value: 'remarks',
                        width: 500
                    }, {
                        text: '是否需要',
                        value: 'isNeedView',
                        width: 100
                    }
                ]
            };
        },
        props: {
            isNexTaskConfig: {
                type: Boolean,
                default: false
            },
            taskList: {
                type: Array
            },
            archiveTemplateTreeList: { // 档案模板树型列表数据
                type: Array
            },
            processInstance: {
                type: Object
            },
            isShowTitle: {
                type: Boolean,
                default: true
            },
            batchTaskAssigneeUserChange: {// 批量修改任务负责人功能
                type: Boolean,
                default: false
            }
        },
        created () {
            // this._initFormsData();
            // this.queryUserList("");
            this.isShowSaveBtn = true;
        },
        computed: {
            ...mapGetters([
                'userInfo'
            ])
        },
        methods: {
            async queryUserList (userName) {
                this.loading = true;
                let userData = await getUserList({ name: userName });
                this.userList = userData.data;
                this.loading = false;
            },
            async handleChange (row) {
                if (row.status === 2) {
                    this.$message({
                        message: '不能干预配置【已完成】状态的任务节点!',
                        type: 'warning',
                        duration: 2000
                    });
                    return false;
                }
                if (row.executor.modeType === 2 && row.status !== 1) {
                    this.$message({
                        message: '只能干预配置【进行中】状态的会签任务节点!',
                        type: 'warning',
                        duration: 2000
                    });
                    return false;
                }
                // console.log(row);
                let taskId = row.taskId;
                let taskName = row.taskName;
                let processServiceId = this.processInstance.processServiceId;
                let deploymentId = this.processInstance.deploymentId;
                // console.log(this.processInstance);
                if (taskId) {
                    let taskData = await getProcessServiceInstanceConfig(processServiceId, deploymentId, this.processInstance.id, taskId);
                    this.taskData = defaultsDeep(taskData, {
                        taskId: taskId,
                        taskName: taskName,
                        processServiceId: processServiceId,
                        deploymentId: deploymentId
                    }, defaultElementData);
                    this.taskTile = '【' + this.processInstance.name + '】: ' + taskData.taskName;
                    this.taskData.executor.isInitconfig = false;
                    this.taskData.processInstanceId = this.processInstance.id;
                    this.taskData.status = row.status;
                    this.taskData.taskInstanceId = row.taskInstanceId;
                    this.isShowEleEditor = true;
                    this.isShowSaveBtn = true;
                }
            },
            async handleSaveConfig () {
                if (this.taskData.nodeInfo.isApproval === 1 && isEmpty(this.taskData.nodeInfo.approvalTemplateList)) {
                    this.$message({message: '当前任务为审批节点，请选择审批流模板！', type: 'warning'});
                    return;
                }
                if (this.taskData.nodeInfo.isSubProcess === 1 && isEmpty(this.taskData.nodeInfo.subProcesslTemplateList)) {
                    this.$message({message: '当前任务为业务流节点，请选择业务流模板！', type: 'warning'});
                    return;
                }
                // console.log(this.taskData);
                if (this.taskData.executor.modeType === 2) { // 会签任务
                    // 校验会签人员是否存在
                    if (isEmpty(this.taskData.executor.countersignUsers)) {
                        this.$message({message: '当前会签节点未配置负责人，请配置后再保存', type: 'warning'});
                        return false;
                    }
                }
    
                this.$confirm(`您确定要修改当前任务配置吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    // 解决未知错误
                    // console.log(this.taskData.nodeInfo.approvalTemplateList);
                    // 转换showAllMyApprovals的值Integer为Boolean
                    if (this.taskData.nodeInfo.approvalTemplateList && this.taskData.nodeInfo.approvalTemplateList.length > 0) {
                        this.taskData.nodeInfo.approvalTemplateList.forEach(element => {
                            element.showAllMyApprovals = (element.showAllMyApprovals > 0);
                        });
                    }
    
                    await interveneProcessTaskConfig(this.taskData);
                    loading.close();
                    this.$emit('refreshProcessList', true);
                    this.isShowEleEditor = false;
                }).catch(() => {});
            },
            handleClick (tab, event) {
                // console.log(tab, event);
            },
            async exportAllUserTaskToExcel () {
                let url = `${API_PROCESS_INSTANCE_ALL_TASK_TO_EXCEL}`;
                url = url.replace(':processInstanceId', this.processInstance.id).replace(':processServiceId', this.processInstance.processServiceId).replace(':processDefinitionId', this.processInstance.processDefinitionId).replace(':deploymentId', this.processInstance.deploymentId).replace(':processInstanceName', this.processInstance.name);
                this.download(url);
            },
            download (url) {
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            hideMainSaveBtn (flg) {
                this.isShowSaveBtn = flg;
            },
            handleSelectionTaskRows (rows) {
                this.batchAuthTaskList = rows;
                // console.log(this.batchAuthTaskList);
                this.selectedTaskIds = '';
                this.selectedTaskInstanceIds = '';
                this.selectedAssingers = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedTaskIds)) {
                                this.selectedTaskIds = row.taskId;
                                this.selectedTaskInstanceIds = row.taskInstanceId;
                                this.selectedAssingers = row.executor.assigneeUsers;
                            } else {
                                this.selectedTaskIds = this.selectedTaskIds + ',' + row.taskId;
                                this.selectedTaskInstanceIds = this.selectedTaskInstanceIds + ',' + row.taskInstanceId;
                                this.selectedAssingers = this.selectedAssingers + ',' + row.executor.assigneeUsers;
                            }
                        }
                    });
                }
            },
            async batchTaskRemoveUser () {
                if (this.batchAuthTaskList && this.batchAuthTaskList.length > 0) {
                    let hasCounterTask = false;// 判断是否选了会签节点
                    let hasCompletedTask = false;// 判断是否选了已完成的节点
                    for (var i = 0; i < this.batchAuthTaskList.length; i++) {
                        if (this.batchAuthTaskList[i].executor.modeType === 2 || this.batchAuthTaskList[i].executor.modeType === 99) {
                            hasCounterTask = true;
                        }
                        if (this.batchAuthTaskList[i].status === 2) {
                            hasCompletedTask = true;
                        }
                    }
                    if (hasCounterTask) { // 会签节点不支持批量选人
                        this.$message({message: '只支持常规任务的负责人批量修改，请修改已经勾选的任务列表', type: 'warning'});
                    } else {
                        if (hasCompletedTask) {
                            this.$message({message: '不能修改已完成任务的负责人，请修改已经勾选的任务列表', type: 'warning'});
                        } else {
                            this.loadTimer = new Date().getTime();
                        }
                        console.log(this.selectedAssingers);
                        if (isEmpty(this.selectedAssingers)) {
                            this.$message({message: '当前任务没有任务负责人，不用移除', type: 'warning'});
                        }
                        let loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        let param = {
                            processInstanceId: this.processInstance.id,
                            selectedTaskInstanceIds: this.selectedTaskInstanceIds,
                            selectedAssingers: this.selectedAssingers
                        };
                        await deleteProcessInstanceUserForced(param);
                        loading.close();
                        this.$emit('refreshProcessList', true);
                    }
                } else {
                    this.$message({message: '请先选择需要移除负责人的任务', type: 'warning'});
                    return false;
                }
            },
            batchTaskChooseUser () { // 批量选任务分责人
                if (this.batchAuthTaskList && this.batchAuthTaskList.length > 0) {
                    let hasCounterTask = false;// 判断是否选了会签节点
                    let hasCompletedTask = false;// 判断是否选了已完成的节点
                    for (var i = 0; i < this.batchAuthTaskList.length; i++) {
                        if (this.batchAuthTaskList[i].executor.modeType === 2 || this.batchAuthTaskList[i].executor.modeType === 99) {
                            hasCounterTask = true;
                        }
                        if (this.batchAuthTaskList[i].status === 2) {
                            hasCompletedTask = true;
                        }
                    }
                    if (hasCounterTask) { // 会签节点不支持批量选人
                        this.$message({message: '只支持常规任务的负责人批量修改，请修改已经勾选的任务列表', type: 'warning'});
                    } else {
                        if (hasCompletedTask) {
                            this.$message({message: '不能修改已完成任务的负责人，请修改已经勾选的任务列表', type: 'warning'});
                        } else {
                            this.loadTimer = new Date().getTime();
                            setTimeout(() => { // 初始化
                                this.$refs.batchTaskUserOrgPop._initPage();
                            }, 0);
                            this.isShowBatchTaskAssignerDialog = true;
                        }
                    }
                } else {
                    this.$message({message: '请先选择需要修改负责人的任务', type: 'warning'});
                    return false;
                }
            },
            batchTaskSelectTrigger (selected) { // 批量选择任务负责人
                this.isShowBatchTaskAssignerDialog = false;
                this.batchTaskSelectedUser = selected;
                this.batchTaskSelectedUser.assignedUserId = selected.selectedUserIds;
                this.batchTaskSelectedUser.assigneeUserName = selected.selectedUserNames;
                // console.log(this.batchTaskSelectedUser.assignedUserId+"========"+this.selectedTaskIds);
                // console.log(this.batchTaskSelectedUser);
                this.batchChangeTaskAssigneeUser();
                // 初始化变量值
                this.selectedTaskIds = '';
                this.batchAuthTaskList = [];
                this.batchTaskSelectedUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
            },
            async batchChangeTaskAssigneeUser () {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let param = {
                    processDefinitionId: this.processInstance.processDefinitionId,
                    processServiceId: this.processInstance.processServiceId,
                    deploymentId: this.processInstance.deploymentId,
                    processInstanceId: this.processInstance.id,
                    taskIds: this.selectedTaskIds,
                    taskAssigneeUserIds: this.batchTaskSelectedUser.assignedUserId
                };
                await batchChangeTaskAssigneeUser(param);
                loading.close();
                this.$emit('refreshProcessList', true);
            },
            async saveProcessCommonUseConfig () {
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let taskConfigInfo = JSON.stringify(this.taskList);
                let param = {
                    processServiceId: this.processInstance.processServiceId,
                    deploymentId: this.processInstance.deploymentId,
                    processInstanceId: this.processInstance.id,
                    processInstanceName: this.processInstance.name,
                    processDefinitionId: this.processInstance.processDefinitionId,
                    taskConfigInfo: taskConfigInfo
    
                };
                // console.log(param);
                await saveProcessCommonUseConfig(param);
                loading.close();
            }
        }
    };
</script>
<style lang="less">
    .task-edit-dialog {
        width: 800px;
        min-width: 600px;
        // max-width: 1200px;
    }

    .el-button--unassigned {
      // color: #409eff;
      // background-color: #c6e2ff;
      // border-color: #ecf5ff;
      color: #909399;
      background: #7FFFD4;
      border-color: #7FFFD4;
    }
    .el-button--unassigned:hover{
      color: #909399;
      background: #7FFFD4;
      border-color: #7FFFD4;
    }

    .el-button--unclaimed {
      // color: #409eff;
      // background-color: #c6e2ff;
      // border-color: #ecf5ff;
      color: #fff;
      background: #FF00FF;
      border-color: #FF00FF;
    }
    .el-button--unclaimed:hover{
      color: #fff;
      background: #FF00FF;
      border-color: #FF00FF;
    }

    .el-button--info.is-plain:hover{
      color: #909399;
      background: #f4f4f5;
      border-color: #d3d4d6;
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/MyProcess/ProcessSetting.vue